import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';

const API_URL = "http://193.123.94.90:8000/get-user-info";

function ChatBox() {
  const navigate = useNavigate();
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [role, setRole] = useState(null);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    const getUser = async () => {
      try {
        const res = await fetch(API_URL, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        if (!res.ok) throw new Error("Failed to fetch user info");

        const data = await res.json();
        setRole(data.role);
      } catch (err) {
        console.error("User info fetch error:", err);
        navigate("/customError");
      }
    };

    getUser();
  }, [navigate]);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const newMessages = [...messages, { from: 'user', text: input }];
    setMessages(newMessages);
    setInput('');

    try {
      const token = localStorage.getItem("token");
      const response = await fetch('http://193.123.94.90/api/chat', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          message: newMessages.slice(-6).map(m => `${m.from}: ${m.text}`).join("\n"),
        }),
      });

      const data = await response.json();
      setMessages([...newMessages, { from: 'bot', text: data.response }]);
    } catch (error) {
      setMessages([...newMessages, { from: 'bot', text: 'Error contacting AI' }]);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      sendMessage();
    }
  };

  return (
    <div style={{ position: "relative", minHeight: "100vh", backgroundColor: "#ffeae9" }}>
      {/* Background overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'url("/background.jpg")',
          backgroundRepeat: 'repeat',
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          opacity: 0.06,
          zIndex: 0
        }}
      ></div>

      <div className="container py-5 position-relative" style={{ zIndex: 1 }}>
        {/* Back button */}
        <div className="position-absolute top-0 start-0 p-3">
          <button
            className="btn btn-sm btn-outline-secondary d-flex align-items-center px-2 py-1"
            style={{ fontSize: "0.8rem", borderRadius: "20px" }}
            onClick={() => navigate("/profile/" + role)}
          >
            <img
              src="/arrow_back.png"
              alt="Back"
              style={{ width: "14px", height: "14px", marginRight: "6px" }}
            />
            Back
          </button>
        </div>

        <div className="bg-white rounded shadow p-4 mx-auto" style={{ maxWidth: '1000px' }}>
          <h1 className="text-center mb-4">Edulink Chatbot</h1>

          <div
            className="mb-3 p-3 rounded"
            style={{
              minHeight: '200px',
              maxHeight: '60vh',
              overflowY: 'auto',
              backgroundColor: '#fff5f5',
              border: '1px solid #f5b5b5'
            }}
          >
            {messages.map((msg, idx) => (
              <div key={idx} className={`mb-2 ${msg.from === 'user' ? 'text-end' : 'text-start'}`}>
                <span
                  className={`d-inline-block p-2 rounded ${msg.from === 'user' ? 'bg-primary text-white' : 'bg-light border'}`}
                >
                  <b>{msg.from === 'user' ? 'You' : 'Chatlink'}:</b> {msg.text}
                </span>
              </div>
            ))}
            <div ref={messagesEndRef} />
          </div>

          <div className="d-flex">
            <input
              type="text"
              className="form-control me-2"
              placeholder="Type a message..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={handleKeyPress}
            />
            <span
              className="btn"
              style={{ backgroundColor: '#f4a29f', color: 'white' }}
              onClick={sendMessage}
            >
              Send
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChatBox;
